import { render, staticRenderFns } from "./inviteRecord.vue?vue&type=template&id=39fd86ee&scoped=true"
import script from "./inviteRecord.vue?vue&type=script&lang=js"
export * from "./inviteRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd86ee",
  null
  
)

export default component.exports